import { render } from "./CoastDevelopment.vue?vue&type=template&id=42d85020"
import script from "./CoastDevelopment.vue?vue&type=script&lang=js"
export * from "./CoastDevelopment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__